import i18n from '../i18n';
import { TranslatedStrings } from '../types';

export const getTranslation = <T extends string>(object: TranslatedStrings<T>, key: T) =>
  i18n.languages[0].startsWith('fr') && object[`${key}_Fr`] ? object[`${key}_Fr`] : object[`${key}_En`];
